export enum CHANNEL_TYPE_GROUP {
  BOT = 'BOT',
  MESSENGER = 'MESSENGER',
  MARKETPLACE = 'MARKETPLACE',
  TELEPHONY = 'TELEPHONY',
  SOCIAL = 'SOCIAL',
  OTHER = 'OTHER',
}

export interface ChannelTypeOption {
  value: string;
  name: string;
  img: string;
  group: CHANNEL_TYPE_GROUP;
  position: number;
  disabled: boolean;
}

export interface ChannelTypesGroup {
  key: CHANNEL_TYPE_GROUP;
  title: string;
  items: ChannelTypeOption[];
}

export interface ChannelTypesPayload {
  selectedType?: string | null;
}

export interface ChannelTypesResult {
  type: string;
}

/** Group order in the sidebar; unknown groups are appended to `OTHER`. */
export const CHANNEL_TYPE_GROUPS_ORDER: CHANNEL_TYPE_GROUP[] = [
  CHANNEL_TYPE_GROUP.MARKETPLACE,
  CHANNEL_TYPE_GROUP.SOCIAL,
  CHANNEL_TYPE_GROUP.MESSENGER,
  CHANNEL_TYPE_GROUP.TELEPHONY,
  CHANNEL_TYPE_GROUP.BOT,
  CHANNEL_TYPE_GROUP.OTHER,
];

export const CHANNEL_TYPE_GROUP_TITLES: Record<CHANNEL_TYPE_GROUP, string> = {
  [CHANNEL_TYPE_GROUP.BOT]: 'channel_types_group.bots',
  [CHANNEL_TYPE_GROUP.MESSENGER]: 'channel_types_group.messengers',
  [CHANNEL_TYPE_GROUP.MARKETPLACE]: 'channel_types_group.marketplaces',
  [CHANNEL_TYPE_GROUP.TELEPHONY]: 'channel_types_group.telephony',
  [CHANNEL_TYPE_GROUP.SOCIAL]: 'channel_types_group.social',
  [CHANNEL_TYPE_GROUP.OTHER]: 'channel_types_group.other',
};
